export const POLYGON_MAIN = 137;
export const POLYGON_AMOY = 80002;
export const ETHER_MAIN = 1;
export const BNB_SMART_CHAIN = 56;
export const TEST_SEPOLIA = 11155111;
